import {
  Bell,
  CalendarRange,
  LayoutGrid,
  MapPinned,
  Megaphone,
  Trophy,
} from 'lucide-react';
import { Card, Description, Heading } from '@heroui/react';

const HIGHLIGHTS = [
  {
    Icon: CalendarRange,
    title: 'Janelas com recorrência',
    body: 'Liberte a vaga na sexta às 18h e recupere no domingo. Uma vez, ou toda semana.',
  },
  {
    Icon: LayoutGrid,
    title: 'Empréstimo ou aluguel',
    body: 'O dono escolhe o tipo. O vizinho filtra, solicita e espera a aprovação.',
  },
] as const;

const SECONDARY = [
  {
    Icon: Megaphone,
    title: 'Solicitação em massa',
    body: 'Não achou vaga no período? Avise todos os proprietários de uma vez.',
  },
  {
    Icon: Trophy,
    title: 'Placar do condomínio',
    body: 'Quem disponibiliza mais pontua. Gamificação que incentiva a colaboração.',
  },
  {
    Icon: MapPinned,
    title: 'Planta da garagem',
    body: 'Cada vaga no mapa do prédio. O morador vê exatamente onde estacionar.',
  },
  {
    Icon: Bell,
    title: 'Notificações no celular',
    body: 'Pedido novo, aprovação, mau uso. O aviso chega sem precisar abrir o app.',
  },
] as const;

export function LandingFeatures() {
  return (
    <section id="produto" className="scroll-mt-24 border-t border-separator">
      <div className="mx-auto flex max-w-6xl flex-col gap-10 px-4 py-16 sm:px-6 lg:py-20">
        <div className="max-w-2xl space-y-3">
          <Heading level={2} className="text-3xl font-bold tracking-tight">
            Tudo que o grupo do prédio não resolve
          </Heading>
          <Description className="text-base">
            Pedido, aprovação, histórico e localização — no mesmo lugar, com regras claras.
          </Description>
        </div>

        <div className="grid gap-4 lg:grid-cols-2">
          {HIGHLIGHTS.map(({ Icon, title, body }) => (
            <Card key={title} className="bg-accent-soft/40">
              <Card.Content className="flex flex-col gap-4 p-6 sm:p-8">
                <div className="flex size-11 items-center justify-center rounded-full bg-accent-soft text-accent">
                  <Icon size={22} />
                </div>
                <Heading level={3} className="text-xl font-semibold">
                  {title}
                </Heading>
                <Description className="text-base">{body}</Description>
              </Card.Content>
            </Card>
          ))}
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {SECONDARY.map(({ Icon, title, body }) => (
            <Card key={title}>
              <Card.Content className="flex flex-col gap-3 p-5">
                <div className="flex size-10 items-center justify-center rounded-full bg-default text-foreground">
                  <Icon size={20} />
                </div>
                <Heading level={3} className="text-base font-semibold">
                  {title}
                </Heading>
                <Description>{body}</Description>
              </Card.Content>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
